import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {ClickEventHandler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ChromelessButton} from '../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface MessageBannerActionProps {
  /** Called whenever the button is clicked. */
  onClick?: ClickEventHandler;
  className?: string;
}

/*
 * Style.
 */

const StyledActionButton = styled(ChromelessButton)`
  padding: 0 8px;
  border-radius: 13px;

  // Move to left by 8px to compensate for hover padding.
  margin-left: -8px;

  font-size: ${fontSizes.tiny};
  font-weight: ${fontWeights.bold};
  line-height: 26px;
  text-transform: uppercase;
  color: ${(p) => p.theme.interactiveText};

  &:hover {
    background-color: ${(p) => p.theme.alphas.gray10};
  }
`;

/*
 * Component.
 */

export const ComposerInfoBannerAction: FC<PropsWithChildren<MessageBannerActionProps>> = (props) => (
  <StyledActionButton className={props.className} onClick={props.onClick}>
    {props.children}
  </StyledActionButton>
);
